import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as angular from "angular";

RLReportParamInput.$inject = ["$compile"];
export function RLReportParamInput($compile: ng.ICompileService) {

    var postLinkFn = (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLReportParamInputController) => {

        // set controller paramKey from pre-compile
        controller.paramKey = attributes["rlReportParamInput"];
        // set any previous value='' from the input so its' not lost by ng-model
        //alert(attributes["value"]);
        controller.paramOutput = attributes["value"];
        controller.paramDisplay = attributes["display"];
        controller.allowMultiple = attributes["allowMultiple"];

        var req = attributes["allowblank"] == "false";
        element.attr("name", attributes["name"]);
        element.attr("type", "hidden");

        if (controller.paramKey.startsWith("p_freetext")) {
            element.attr("value", "{{rpiVM.paramDisplay}}");
            var outerDiv = angular.element("<div></div>");
            var inputGroupDiv = angular.element("<div class='input-group'></div>");
            var displayInput = angular.element("<input type='text' class='form-control' ng-model='rpiVM.paramDisplay' ng-model='rpiVM.paramOutput'" + (req ? "required='required'" : "") + " />").attr("placeholder", attributes["placeholder"]);
            var button = angular.element("<span class='input-group-btn'><button class='btn btn-default' type='button' title='Clear Selection' ng-click='rpiVM.ClearSelection()'><i class='fa fa-times'></i></button></span>");

            element.wrap(outerDiv);
            element.wrap(inputGroupDiv);
            element.after(button);
            element.after(displayInput);
        }
        else {
            element.attr("value", "{{rpiVM.paramOutput}}");
            var outerDiv = angular.element("<div></div>");
            var inputGroupDiv = angular.element("<div class='input-group'></div>");
            var displayInput = angular.element("<input type='text' class='form-control' ng-model='rpiVM.paramDisplay' ng-click='rpiVM.OpenModal()'" + (req ? "required='required'" : "") + " />").attr("placeholder", attributes["placeholder"]);
            var button = angular.element("<span class='input-group-btn'><button class='btn btn-default' type='button' title='Clear Selection' ng-click='rpiVM.ClearSelection()'><i class='fa fa-times'></i></button></span>");
            var paramPicker = angular.element("<div rl-report-param-picker-modal='rpiVM.paramKey' param-output='rpiVM.paramOutput' param-display='rpiVM.paramDisplay' modal-open='rpiVM.modalOpen' mode='rpiVM.mode' allow-multiple='rpiVM.allowMultiple'/>");

            element.wrap(outerDiv);
            element.after(paramPicker);
            element.wrap(inputGroupDiv);
            element.after(button);
            element.after(displayInput);
        }

        // run compile on new stuff
        var compiled = $compile(element.parent().parent());
        compiled(scope);
    };

    var directive: ng.IDirective = {
        restrict: "A",
        controller: RLReportParamInputController,
        controllerAs: "rpiVM",
        require: "rlReportParamInput",
        scope: {},
        bindToController: {
            paramOutput: "=",
            paramDisplay: "="
        },
        compile: (tElement: ng.IAugmentedJQuery, tAttrs: ng.IAttributes) => {
            // store param key for postcompile
            tElement.attr("rl-param-key", tElement.attr("rl-report-param-input"));
            // remove directive to prevent recursion
            tElement.removeAttr("rl-report-param-input");
            // set ng-model
            tElement.attr("ng-model", "rpiVM.paramOutput");
            return postLinkFn;
        }
    };
    return directive;
}

class RLReportParamInputController {

    static $inject = ["$scope"];

    paramKey: string;
    paramOutput: string;
    paramDisplay: string;
    modalOpen: boolean;
    mode: string;
    allowMultiple: boolean;

    constructor(private $scope: ng.IScope) {
        this.modalOpen = false;
        this.mode = "";

        $scope.$on('ssrsReportParamsClear', () => {
            this.paramOutput = "";
            this.paramDisplay = "";
        });

        $scope.$watch(() => this.paramDisplay, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (this.paramKey.startsWith('p_freetext')) {
                    this.paramOutput = this.paramDisplay;
                }
            }
        });
    }

    OpenModal() {
        this.modalOpen = true;
    }

    ClearSelection() {
        this.paramOutput = "";
        this.paramDisplay = "";
    }
}
